<div 
    *ngIf="this.assessCase && !this.loading" class="z-20 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); onCloseClick();"
>
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="h-full w-full max-w-screen-xl flex flex-col my-6 p-8 gap-4 bg-white rounded-md shadow-lg overflow-y-auto" (click)="$event.stopPropagation()">
            <div class="flex items-center justify-between">
                <h2 class="oswald-font text-2xl">ROAR Assignments and Activity Logs for Case {{ assessCase.case_id }}</h2>                
            <button
                class="w-22 px-2.5 py-1 rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:from-nside-orange-100 hover:to-nside-orange-200 text-white text-lg oswald-font flex items-center justify-center gap-2"
                (click)="$event.preventDefault(); createRoarAssignmentForm(this.assessCase);"
            >
                <lucide-icon [img]="icons.Plus"></lucide-icon>
                Create New Roar Assignment Form
            </button>
            </div>
            <div class="h-full overflow-y-auto">
                <ng-container *ngIf="allRoarAssignments.length > 0; else emptyRoarAssignment">
                    <table class="h-full w-full text-left">
                        <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                            <tr>
                                <th scope="col" class="px-6 py-3">No.</th>
                                <th scope="col" class="px-6 py-3">Info</th>
                                <th scope="col" class="px-6 py-3">Activity</th>
                                <th scope="col" class="px-6 py-3">Review</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of allRoarAssignments; let i = index" class="bg-white border-b">
                                <th scope="row" class="px-6 py-4">
                                    {{ i + 1 }}
                                </th>
                                <td class="px-6 py-4">
                                    <p class="font-semibold">Category: <span class="font-normal">{{ item.roar_category }}</span></p>
                                    <p class="font-semibold">Type: <span class="font-normal">{{ item.roar_type }}</span></p>
                                    <p *ngIf="item.review !== undefined && item.review+'' === yesNo.Yes" class="font-semibold">Review Required: <span class="font-normal">Yes</span></p>
                                    <p *ngIf="item.review !== undefined && item.review+'' === yesNo.No" class="font-semibold">Review Required: <span class="font-normal">No</span></p>
                                    <button
                                        *ngIf="item.roar_assignment_form_completion+'' === yesNo.No"
                                        class="underline text-nside-orange-400 hover:text-gray-text"
                                        (click)="$event.preventDefault(); onFormClick('form/roar-assignment-form', item.case_id, item.roar_id);"
                                    >
                                        Continue Form
                                    </button>
                                    <button
                                        *ngIf="item.roar_assignment_form_completion+'' === yesNo.Yes" 
                                        class="underline text-nside-orange-400 hover:text-gray-text"
                                        (click)="$event.preventDefault(); onViewFormOpen(item);"
                                    >
                                        Details
                                    </button>
                                </td>
                                <td class="px-6 py-4">
                                    <p *ngIf="item.roar_activity_completion+'' === yesNo.Yes" class="font-semibold">Completed: <span class="font-normal">Yes</span></p>
                                    <p *ngIf="item.roar_activity_completion+'' === yesNo.No" class="font-semibold">Completed: <span class="font-normal">No</span></p>
                                    <p *ngIf="item.user_assigned" class="font-semibold">Assigned To: <span class="font-normal">{{ item.username_assigned }}</span></p>
                                    <button
                                        *ngIf="item.assign_to_this_user && 
                                            item.roar_assignment_form_completion+'' === yesNo.Yes && 
                                            item.roar_activity_completion+'' === yesNo.No && 
                                            item.review_section_completion+'' === yesNo.No"
                                        class="underline text-nside-orange-400 hover:text-gray-text"
                                        (click)="$event.preventDefault(); onFormClick('form/roar-activity', item.case_id, item.roar_id);"
                                    >
                                        Log activity
                                    </button>
                                </td>
                                <td class="px-6 py-4">
                                    <ng-container *ngIf="item.review+'' === yesNo.Yes; else reviewNotRequired">
                                        <p *ngIf="item.roar_review_completion+'' === yesNo.Yes" class="font-semibold">Completed: <span class="font-normal">Yes</span></p>
                                        <p *ngIf="item.roar_review_completion+'' === yesNo.No" class="font-semibold">Completed: <span class="font-normal">No</span></p>
                                    </ng-container>
                                    <ng-template #reviewNotRequired>
                                        <p class="font-semibold">Completed: <span class="font-normal">Not Required</span></p>
                                    </ng-template>
                                    <p *ngIf="item.review_user_signature_name" class="font-semibold">Completed By: <span class="font-normal">{{ item.review_user_signature_name }}</span></p>
                                    <button
                                        *ngIf="item.review+'' === yesNo.Yes && 
                                            item.roar_activity_completion+'' === yesNo.Yes && 
                                            item.roar_review_completion+'' === yesNo.No"
                                        class="underline text-nside-orange-400 hover:text-gray-text"
                                        (click)="$event.preventDefault(); onFormClick('form/roar-review', item.case_id, item.roar_id);"
                                    >
                                        Review
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>
                
                <ng-template #emptyRoarAssignment>
                    <div class="w-full text-nside-gray-100 italic">
                        Empty Roar Assignment
                    </div>
                </ng-template>
            </div>
            <div class="mt-4 flex justify-end gap-4">
                <button
                    class="px-4 py-2 flex flex-row gap-2 items-center justify-center rounded-md oswald-font uppercase text-white border border-nside-gray-100 bg-gradient-to-b from-nside-gray-100 to-nside-gray-200 hover:bg-gradient-to-b hover:from-nside-gray-300 hover:to-nside-gray-400"
                    (click)="$event.preventDefault(); onCloseClick();"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="this.selectedRoarAssignment" class="z-30 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); this.selectedRoarAssignment = null;">
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="h-full w-full max-w-screen-md flex flex-col my-6 p-8 gap-4 bg-white rounded-md shadow-lg overflow-y-auto" (click)="$event.stopPropagation()">
            <div class="w-full h-full flex flex-col gap-4 overflow-y-auto">
                <div class="w-full flex flex-col items-center justify-center gap-2">
                    <h2 class="w-full oswald-font text-2xl text-nside-orange-400">ROAR Assignments Form</h2>
                    <review-roar class="w-full h-full"[roarId]="this.selectedRoarAssignment.roar_id"></review-roar>
                </div>
                <div *ngIf="this.selectedRoarAssignment.roar_activity_completion+'' === yesNo.Yes" class="w-full flex flex-col items-center justify-center gap-2">
                    <h2 class="w-full oswald-font text-2xl text-nside-orange-400">ROAR Activity</h2>
                    <review-roar-activity class="w-full h-full"[roarId]="this.selectedRoarAssignment.roar_id"></review-roar-activity>
                </div>
                <div *ngIf="this.selectedRoarAssignment.roar_review_completion+'' === yesNo.Yes" class="w-full flex flex-col items-center justify-center gap-2">
                    <h2 class="w-full oswald-font text-2xl text-nside-orange-400">ROAR Activity Review</h2>
                    <review-roar-activity-review class="w-full h-full"[roarId]="this.selectedRoarAssignment.roar_id"></review-roar-activity-review>
                </div>
            </div>
            <div class="mt-4 flex justify-end gap-4">
                <button
                    class="px-4 py-2 flex flex-row gap-2 items-center justify-center rounded-md oswald-font uppercase text-white border border-nside-gray-100 bg-gradient-to-b from-nside-gray-100 to-nside-gray-200 hover:bg-gradient-to-b hover:from-nside-gray-300 hover:to-nside-gray-400"
                    (click)="$event.preventDefault(); this.selectedRoarAssignment = null;"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    (close)="resetMessageModal()"
    [message]="popupMessage"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>